import axios from 'axios'
import store from '@/store/index'
import router from '@/router/index'
import { api } from '@/api'

axios.interceptors.request.use(config => {
  config.headers['X-Requested-With'] = 'XMLHttpRequest'

  const token = store.getters['auth/token']
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token
  }

  return config
}, error => {
  //console.log("error1="+JSON.stringify(error));
  return Promise.reject(error)
})

axios.interceptors.response.use(response => {
  return response
}, async error => {

  //console.log("error2="+JSON.stringify(error.response.data.data.message));
  if (store.getters['auth/token']) 
  {

    if (error.response.status === 401 && error.response.data.message === 'Token has expired') 
    {
        // TODO: add pop out dialog shown session expired - by JUN
      store.dispatch('auth/destroy')
      router.push({ name: 'login' })

      return Promise.reject(error)
    }
  }

  if(error.response.status === 422)
  {
     if( error.response.data.data.message !== undefined)
     {
       return Promise.reject(error);
     }
  } 
  // else {
  //     error.response.data.message !== undefined && this.$toastr.e(error.response.data.data.message || 'Something went wrong.')
  //     error.response.data.error !== undefined && this.$toast.e(error.response.data.data.error || 'Error occurred.')
  // }

  return Promise.reject(error)
})

// make axios access globally without uisng "this."
window.axios = axios
